/**
  不会出现在菜单中的基本路由
  wk 2020-03-03
*/
import Login from '../views/login/index.vue'

const routers = [
	{
		path: '/',
		name: 'login',
		component: Login
	},
	{
		path: '/register',
		name: 'register',
		component: () => import('../views/register/index.vue')
	},

]

export default routers
